import AsyncStorage from '@react-native-async-storage/async-storage';
import { STORAGE_KEYS } from './utils';
const usePersistentState = (initialValues) => {
  const saveState = async (state) => {
    const currentDate = new Date().toISOString().slice(0, 10);

    try {
      const validMultiplier = !isNaN(state.multiplier) && state.multiplier >= 1 ? state.multiplier : 1;
      const validAccumulator = 
        !isNaN(state.accumulatorProgress) && 
        state.accumulatorProgress >= 0 && 
        state.accumulatorProgress <= 1 ? state.accumulatorProgress : 0;
      const validScore = !isNaN(state.score) && state.score >= 0 ? state.score : 0;

      try {
        await AsyncStorage.multiSet([
          [STORAGE_KEYS.DATE, currentDate],
          [STORAGE_KEYS.MULTIPLIER, String(validMultiplier)],
          [STORAGE_KEYS.ACCUMULATOR, String(validAccumulator)],
          [STORAGE_KEYS.SCORE, String(validScore)]
        ]);
        return true;
      } catch (storageError) {
        const saveItem = async (key, value) => {
          try {
            await AsyncStorage.setItem(key, String(value));
            return true;
          } catch (e) {
            return false;
          }
        };

        const results = await Promise.all([
          saveItem(STORAGE_KEYS.DATE, currentDate),
          saveItem(STORAGE_KEYS.MULTIPLIER, validMultiplier),
          saveItem(STORAGE_KEYS.ACCUMULATOR, validAccumulator),
          saveItem(STORAGE_KEYS.SCORE, validScore)
        ]);

        return results.every(Boolean);
      }
    } catch (error) {
      return false;
    }
  };
  const loadState = async () => {
    try {
      const currentDate = new Date().toISOString().slice(0, 10);
      let stateToSet = {...initialValues};

      try {
        const keys = Object.values(STORAGE_KEYS);
        const results = await AsyncStorage.multiGet(keys);
        
        const resultsObj = {};
        results.forEach(item => {
          resultsObj[item[0]] = item[1];
        });

        const savedDate = resultsObj[STORAGE_KEYS.DATE] || null;
        const savedMultiplierStr = resultsObj[STORAGE_KEYS.MULTIPLIER] || '1';
        const savedAccumulatorStr = resultsObj[STORAGE_KEYS.ACCUMULATOR] || '0';
        const savedScoreStr = resultsObj[STORAGE_KEYS.SCORE] || '0';

        const datesMatch = savedDate === currentDate;

        if (datesMatch) {
          try {
            const multiplier = parseInt(savedMultiplierStr, 10);
            if (!isNaN(multiplier) && multiplier >= 1) {
              stateToSet.multiplier = multiplier;
            }
          } catch (e) {}

          try {
            const accumulatorProgress = parseFloat(savedAccumulatorStr);
            if (
              !isNaN(accumulatorProgress) &&
              accumulatorProgress >= 0 &&
              accumulatorProgress <= 1
            ) {
              stateToSet.accumulatorProgress = accumulatorProgress;
            }
          } catch (e) {}

          try {
            const score = parseInt(savedScoreStr, 10);
            if (!isNaN(score) && score >= 0) {
              stateToSet.score = score;
            }
          } catch (e) {}
        }
      } catch (multiGetError) {
        const retrieveItem = async (key, defaultValue) => {
          try {
            const value = await AsyncStorage.getItem(key);
            return value !== null ? value : defaultValue;
          } catch (e) {
            return defaultValue;
          }
        };

        const savedDate = await retrieveItem(STORAGE_KEYS.DATE, null);
        const savedMultiplierStr = await retrieveItem(STORAGE_KEYS.MULTIPLIER, '1');
        const savedAccumulatorStr = await retrieveItem(STORAGE_KEYS.ACCUMULATOR, '0');
        const savedScoreStr = await retrieveItem(STORAGE_KEYS.SCORE, '0');

        const datesMatch = savedDate === currentDate;

        if (datesMatch) {
          try {
            const multiplier = parseInt(savedMultiplierStr, 10);
            if (!isNaN(multiplier) && multiplier >= 1) {
              stateToSet.multiplier = multiplier;
            }
          } catch (e) {}

          try {
            const accumulatorProgress = parseFloat(savedAccumulatorStr);
            if (
              !isNaN(accumulatorProgress) &&
              accumulatorProgress >= 0 &&
              accumulatorProgress <= 1
            ) {
              stateToSet.accumulatorProgress = accumulatorProgress;
            }
          } catch (e) {}

          try {
            const score = parseInt(savedScoreStr, 10);
            if (!isNaN(score) && score >= 0) {
              stateToSet.score = score;
            }
          } catch (e) {}
        }
      }

      return stateToSet;
    } catch (error) {
      return initialValues;
    }
  };

  const initializeState = async () => {
    const currentDate = new Date().toISOString().slice(0, 10);
    const savedDate = await AsyncStorage.getItem(STORAGE_KEYS.DATE);

    if (savedDate === currentDate) {
      return await loadState();
    } else {
      await AsyncStorage.setItem(STORAGE_KEYS.DATE, currentDate);
      return initialValues;
    }
  };

  return {
    saveState,
    loadState,
    initializeState
  };
};

export default usePersistentState;
